import type { Currency } from '@shared/utils';
import { API_ROUTES } from './routes';
import { ApiService } from './service';

type GameInfoResponse = {
  name: string;
  playURL: string;
  image: string;
  minimumStake: number;
  provider: string[];
  categories: string[];
  volatility: string[];
  currencySymbol: string;
  gameImageUrlMobile: string;
  gameImageUrlDesktop: string;
  description?: string;
  seoTitle?: string;
  seoDescription?: string;
  content: string;
  instructions: string;
};

/**
 * Fetches game info for a locale, currency and game name.
 *
 * Returns `null` when the game isn't found (HTTP 404) or the response has no data,
 * so callers can render a 404 page. Any other failure throws.
 */
async function getGameInfo(apiUrl: string, locale: string, currency: Currency, gameName: string): Promise<GameInfoResponse | null> {
  const apiService = ApiService.getInstance(apiUrl);
  const route = API_ROUTES.GAMES.GAME_INFO.replace(':locale', locale).replace(':currency', currency).replace(':gameName', gameName);
  const response = await apiService.get<GameInfoResponse>(route);

  if (response.status === 404) {
    return null;
  }

  if (response.error) {
    throw response.error;
  }

  return response.data;
}

export { getGameInfo, type GameInfoResponse };
